import { render, staticRenderFns } from "./PublicMarketplaceCollectionList.vue?vue&type=template&id=2028e2ab&"
import script from "./PublicMarketplaceCollectionList.vue?vue&type=script&lang=js&"
export * from "./PublicMarketplaceCollectionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports